import React from "react";
import { CheckCircleTwoTone } from "@ant-design/icons";

/**
 * Helper function converting a true bool to a checkmark or an empty cell
 * @param {*} value
 */
const boolToCheckmark = (value) => {
  return value ? <CheckCircleTwoTone twoToneColor="#52c41a" /> : null;
};

export { boolToCheckmark };
